/**
 * PostHog event names — snake_case per WB-2122 conventions.
 * Only referenced by the PostHog adapter and mappers.
 */
export const PostHogEventName = {
    pageview: '$pageview',
    pageleave: '$pageleave',
    sessionStarted: 'session_started',
    sessionEnded: 'session_ended',
    login: 'login',
    appLoaded: 'app_loaded',
    penSwitched: 'pen_switched',
    /**
     * Follows `pen_switched` once the destination cage dashboard overview has rendered.
     * Duration cannot live on `pen_switched`, which fires at the click.
     */
    penSwitchRendered: 'pen_switch_rendered',
    exportTriggered: 'export_triggered',
    compareFunctionUsed: 'compare_function_used',
    reportCreated: 'report_created',
    reportDownloaded: 'report_downloaded',
    featureUsed: 'feature_used',
    errorEncountered: 'error_encountered',
    quickSearchOpened: 'quick_search_opened',
    quickSearchResultSelected: 'quick_search_result_selected',
    buttonClicked: 'button_clicked',
} as const;

export type PostHogEventNameValue = (typeof PostHogEventName)[keyof typeof PostHogEventName];
